export const BASE = process.env.REACT_APP_API_URL ?? "http://localhost:8001";

const token = () => localStorage.getItem("kb_admin_token");

async function req(method, path, body) {
    const headers = { "Content-Type": "application/json" };
    const t = token();
    if (t) headers["Authorization"] = `Bearer ${t}`;

    const res = await fetch(`${BASE}/api${path}`, {
        method,
        headers,
        body: body !== undefined ? JSON.stringify(body) : undefined,
    });

    if (!res.ok) {
        const err = await res.json().catch(() => ({ detail: "Server error" }));
        const detail = err.detail;
        const message = typeof detail === "string"
            ? detail
            : Array.isArray(detail)
                ? detail.map(d => (typeof d === "string" ? d : d.msg || JSON.stringify(d))).join("; ")
                : "Chyba servera";
        throw new Error(message);
    }
    if (res.status === 204) return null;
    return res.json();
}

export async function uploadFile(file) {
    const t = localStorage.getItem("kb_admin_token");
    const form = new FormData();
    form.append("file", file);
    const res = await fetch(`${BASE}/api/upload`, {
        method: "POST",
        headers: t ? { Authorization: `Bearer ${t}` } : {},
        body: form,
    });
    if (!res.ok) {
        const err = await res.json().catch(() => ({ detail: "Upload zlyhal" }));
        throw new Error(err.detail || "Upload zlyhal");
    }
    return res.json(); // { url: "/static/uploads/xxx.webp", thumb_url: "/static/uploads/xxx_thumb.webp" }
}

export async function uploadLogoFile(file) {
    const t = localStorage.getItem("kb_admin_token");
    const form = new FormData();
    form.append("file", file);
    const res = await fetch(`${BASE}/api/upload-logo`, {
        method: "POST",
        headers: t ? { Authorization: `Bearer ${t}` } : {},
        body: form,
    });
    if (!res.ok) {
        const err = await res.json().catch(() => ({ detail: "Upload zlyhal" }));
        throw new Error(err.detail || "Upload zlyhal");
    }
    return res.json();
}

export const api = {
    // Auth
    login:        (username, password) => req("POST", "/auth/login", { username, password }),
    login2fa:     (partial_token, code) => req("POST", "/auth/login/2fa", { partial_token, code }),
    me:           ()                    => req("GET",  "/auth/me"),

    // 2FA management
    setup2fa:   () => req("POST", "/admin/2fa/setup"),
    enable2fa:  (code) => req("POST", "/admin/2fa/enable", { code }),
    disable2fa: (code) => req("POST", "/admin/2fa/disable", { code }),
    changeOwnPassword: (current_password, new_password) => req("PUT", "/admin/auth/password", { current_password, new_password }),

    // User management (superadmin only)
    listUsers:          ()                       => req("GET",    "/admin/users"),
    createUser:         (username, password, role) => req("POST", "/admin/users", { username, password, role }),
    changeUserPassword: (username, new_password) => req("PUT",    `/admin/users/${username}/password`, { new_password }),
    changeUserRole:     (username, role)         => req("PUT",    `/admin/users/${username}/role`, { role }),
    deleteUser:         (username)               => req("DELETE", `/admin/users/${username}`),

    // Audit log (superadmin only)
    getAuditLog: (skip = 0, limit = 50) => req("GET", `/admin/audit?skip=${skip}&limit=${limit}`),

    // Stats
    stats:   () => req("GET", "/stats"),

    // Referencie
    getReferencie:      ()          => req("GET",    "/referencie"),
    createReferencia:   (data)      => req("POST",   "/referencie",       data),
    updateReferencia:   (id, data)  => req("PUT",    `/referencie/${id}`, data),
    deleteReferencia:   (id)        => req("DELETE", `/referencie/${id}`),

    // Technika
    getTechnika:         ()           => req("GET",    "/technika"),
    getFeaturedTechnika: ()           => req("GET",    "/technika/featured"),
    createEquipment:     (data)       => req("POST",   "/technika",                 data),
    updateEquipment:     (id, data)   => req("PUT",    `/technika/${id}`,           data),
    toggleFeatured:      (id, val)    => req("PATCH",  `/technika/${id}/featured`,  { featured: val }),
    deleteEquipment:     (id)         => req("DELETE", `/technika/${id}`),

    // Technika categories
    getTechnikaCategories:  ()           => req("GET",    "/technika/categories"),
    createTechnikaCategory: (data)       => req("POST",   "/technika/categories",          data),
    updateTechnikaCategory: (slug, data) => req("PUT",    `/technika/categories/${slug}`,   data),
    deleteTechnikaCategory: (slug)       => req("DELETE", `/technika/categories/${slug}`),

    // Sluzby
    getSluzby:      ()            => req("GET",    "/sluzby"),
    getSluzba:      (slug)        => req("GET",    `/sluzby/${slug}`),
    createSluzba:   (data)        => req("POST",   "/sluzby", data),
    updateSluzba:   (slug, data)  => req("PUT",    `/sluzby/${slug}`, data),
    deleteSluzba:   (slug)        => req("DELETE", `/sluzby/${slug}`),

    // Brands
    getBrands:      ()            => req("GET",    "/brands"),
    getBrandsAll:   ()            => req("GET",    "/brands/all"),
    createBrand:    (data)        => req("POST",   "/brands", data),
    updateBrand:    (id, data)    => req("PUT",    `/brands/${id}`, data),
    deleteBrand:    (id)          => req("DELETE", `/brands/${id}`),

    // Google Reviews
    getGoogleReviews:    ()       => req("GET",  "/google/reviews"),
    getGoogleSettings:   ()       => req("GET",  "/settings/google"),
    updateGoogleSettings:(data)   => req("PUT",  "/settings/google",       data),
    testGoogleConnection:()       => req("POST", "/settings/google/test"),

    // Facebook
    getFacebookPosts:  ()       => req("GET",  "/facebook/posts"),
    getFbSettings:     ()       => req("GET",  "/settings/facebook"),
    updateFbSettings:  (data)   => req("PUT",  "/settings/facebook",       data),
    testFbConnection:  ()       => req("POST", "/settings/facebook/test"),

    // Contact
    sendContact:        (data)      => req("POST",   "/contact",              data),
    getContacts:        ()          => req("GET",    "/contacts"),
    markContactRead:    (id)        => req("PATCH",  `/contacts/${id}/read`),
    deleteContact:      (id)        => req("DELETE", `/contacts/${id}`),

    // Rental / Bookings
    getRentableTechnika:        ()          => req("GET",    "/technika/rentable"),
    getEquipmentAvailability:   (id)        => req("GET",    `/technika/${id}/availability`),
    createBooking:              (data)      => req("POST",   "/bookings",                data),
    getBookings:                ()          => req("GET",    "/bookings"),
    updateBookingStatus:        (id, status)=> req("PATCH",  `/bookings/${id}/status`,   { status }),
    markBookingRead:            (id)        => req("PATCH",  `/bookings/${id}/read`),
    deleteBooking:              (id)        => req("DELETE", `/bookings/${id}`),

    // Testimonials
    getTestimonials:    ()          => req("GET",    "/testimonials"),
    createTestimonial:  (data)      => req("POST",   "/testimonials",         data),
    updateTestimonial:  (id, data)  => req("PUT",    `/testimonials/${id}`,   data),
    deleteTestimonial:  (id)        => req("DELETE", `/testimonials/${id}`),

    // Partners
    getPartners:    ()          => req("GET",    "/partners"),
    createPartner:  (data)      => req("POST",   "/partners",         data),
    updatePartner:  (id, data)  => req("PUT",    `/partners/${id}`,   data),
    deletePartner:  (id)        => req("DELETE", `/partners/${id}`),

    // 3D Models
    getModels3d:    ()          => req("GET",    "/models3d"),
    createModel3d:  (data)      => req("POST",   "/models3d",         data),
    updateModel3d:  (id, data)  => req("PUT",    `/models3d/${id}`,   data),
    deleteModel3d:  (id)        => req("DELETE", `/models3d/${id}`),

    // Visitor stats
    recordHit:           (path, referrer) => req("POST", "/stats/hit", { path, referrer }),
    getVisitorSummary:   ()               => req("GET",  "/stats/visitor-summary"),

    // Site settings
    getSettings:    ()      => req("GET", "/settings"),
    saveSettings:   (data)  => req("PUT", "/settings", data),

    // SMTP settings
    getSmtpSettings:  ()      => req("GET",  "/settings/smtp"),
    saveSmtpSettings: (data)  => req("PUT",  "/settings/smtp", data),
    testSmtp:         ()      => req("POST", "/settings/smtp/test"),

    // Backups
    listBackups:    ()              => req("GET",    "/backups"),
    createBackup:   ()              => req("POST",   "/backups"),
    restoreBackup:  (name, drop)    => req("POST",   `/backups/${name}/restore?drop=${!!drop}`),
    deleteBackup:   (name)          => req("DELETE", `/backups/${name}`),
    downloadBackupUrl: (name)       => `${BASE}/api/backups/${name}/download`,
    sendBackupToNas:(name)          => req("POST",   `/admin/backups/${name}/send-to-nas`),

    // Backup schedule
    getBackupSchedule:  ()      => req("GET",  "/admin/backup-schedule"),
    saveBackupSchedule: (data)  => req("PUT",  "/admin/backup-schedule", data),
    testNas:            ()      => req("POST", "/admin/backup-schedule/test-nas"),
    triggerBackupNow:   ()      => req("POST", "/admin/backup-schedule/run-now"),
};

export async function upload3dFile(file) {
    const t = localStorage.getItem("kb_admin_token");
    const form = new FormData();
    form.append("file", file);
    const res = await fetch(`${BASE}/api/upload3d`, {
        method: "POST",
        headers: t ? { Authorization: `Bearer ${t}` } : {},
        body: form,
    });
    if (!res.ok) {
        const err = await res.json().catch(() => ({ detail: "Upload zlyhal" }));
        throw new Error(err.detail || "Upload zlyhal");
    }
    return res.json();
}

export async function uploadBackup(file) {
    const t = localStorage.getItem("kb_admin_token");
    const form = new FormData();
    form.append("file", file);
    const res = await fetch(`${BASE}/api/backups/upload`, {
        method: "POST",
        headers: t ? { Authorization: `Bearer ${t}` } : {},
        body: form,
    });
    if (!res.ok) {
        const err = await res.json().catch(() => ({ detail: "Upload zlyhal" }));
        throw new Error(err.detail || "Upload zlyhal");
    }
    return res.json();
}
